import { addMoveListener } from 'lib/events-framework/moveListener'
import { useEffect, useRef, useState } from 'react'

type Coordinates = [number, number]

type Config = {
  position: Coordinates
  onPositionChange: (newCoords: Coordinates) => void
  onDrop?: (dropDiff: Coordinates) => void
  interactiveDirection?: 'horizontal' | 'vertical' | 'both'
}

export const useRelativeDrag = ({ position, onDrop, onPositionChange, interactiveDirection = 'both' }: Config) => {
  const [picked, setPicked] = useState(false)
  const [pointerPickPosition, setPointerPickPosition] = useState<Coordinates>([0, 0])
  const [elementPickPosition, setElementPickPosition] = useState<Coordinates>([0, 0])
  const removeMoveListener = useRef(() => {})

  useEffect(() => {
    const handler = ([x, y]: Coordinates) => {
      onPositionChange([
        elementPickPosition[0] + (x - pointerPickPosition[0]),
        elementPickPosition[1] + (y - pointerPickPosition[1])
      ])
    }

    if (picked) {
      removeMoveListener.current = addMoveListener(handler, pointerPickPosition, interactiveDirection)
    }

    return () => removeMoveListener.current()
  }, [elementPickPosition, pointerPickPosition, picked, onPositionChange])

  const pick = (e: React.PointerEvent) => {
    setPointerPickPosition([e.clientX, e.clientY])
    setElementPickPosition(position)
    setPicked(true)
  }

  useEffect(() => {
    const handler = (e: PointerEvent) => {
      if (picked) {
        setPicked(false)

        onDrop &&
          onDrop([
            elementPickPosition[0] + (e.clientX - pointerPickPosition[0]),
            elementPickPosition[1] + (e.clientY - pointerPickPosition[1])
          ])
      }
    }
    window.addEventListener('pointerup', handler)
    return () => {
      window.removeEventListener('pointerup', handler)
    }
  }, [elementPickPosition, onDrop, picked, pointerPickPosition])

  return { pick, picked }
}
